import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { tenantHasModule, type TenantModule } from '@kennisbank/shared';
import { useAuth } from './AuthProvider.js';

/**
 * Frontend-poort per tenant-module (ADR 0018). Defense in depth: de backend
 * weigert de routes van een uitgezette module al met 403. Zonder `fallback`
 * gaat de gebruiker terug naar de startpagina; met `fallback` (Sara) toont de
 * pagina een uitleg in plaats van te verdwijnen.
 */
export function ModuleGuard({
  module,
  fallback,
  children,
}: {
  module: TenantModule;
  fallback?: ReactNode;
  children: ReactNode;
}): JSX.Element {
  const { user, loading } = useAuth();
  if (loading) return <></>;
  if (!user) return <Navigate to="/login" replace />;
  if (!tenantHasModule(user.tenantId, module)) {
    return fallback !== undefined ? <>{fallback}</> : <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
